import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';

import {
    BB_BETCARD_FOOTER_CSS_CLASS_FEED,
    BB_BETCARD_FOOTER_CSS_CLASS_HIGHLIGHT,
    BB_BETCARD_FOOTER_ICON_CSS_CLASS_BLOCK_NAME,
    BB_BETCARD_FOOTER_CSS_CLASS_TOP,
    I18N_BETCARD_MOST_POPULAR,
    I18N_BETCARD_MOST_POPULAR_NAME,
} from '../../constants';

const MostPopularFooter = ({isTopBet, position, sportName}) => {
    const [t] = useTranslation();
    const one = 1;
    const i18Key = sportName ? I18N_BETCARD_MOST_POPULAR_NAME : I18N_BETCARD_MOST_POPULAR;

    return (
        <div className={classnames([BB_BETCARD_FOOTER_ICON_CSS_CLASS_BLOCK_NAME, {
            [BB_BETCARD_FOOTER_CSS_CLASS_TOP]: isTopBet,
            [BB_BETCARD_FOOTER_CSS_CLASS_FEED]: !isTopBet,
        }])}>
            <Trans t={t} i18nKey={i18Key} count={`#${position + one}`}>
                <span className={BB_BETCARD_FOOTER_CSS_CLASS_HIGHLIGHT} />
            </Trans> {sportName ? sportName : ''}
        </div>
    );
};

MostPopularFooter.propTypes = {
    position: PropTypes.number.isRequired,
    isTopBet: PropTypes.bool,
    sportName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
};

MostPopularFooter.defaultProps = {
    isTopBet: false,
    sportName: null,
};

export default MostPopularFooter;
